import ArticleCard from "@elements/Card/Article/ArticleCard";
import LatestNewsHeader from "@elements/LatestNews/LatestNewsHeader";
import { isArrayWithElements } from "@helper/utils";
import useSwrApi from "@hooks/useSwrApi";
import type { ProcessedArticleData } from "@transformer/useOSResponse";

export default function LatestNews() {
  const { data: breakingNews } =
    useSwrApi<ProcessedArticleData[]>("breaking-news");

  return isArrayWithElements(breakingNews) ? (
    <div className="flex flex-col w-full px-6 mt-md">
      <LatestNewsHeader />
      <div className="flex flex-col w-full gap-y-lg mb-lg lg:min-h-[500px]">
        {breakingNews.map((article) => (
          <ArticleCard
            key={article.id}
            displayWidth={0}
            displayHeight={0}
            elements={{
              hasImage: false,
              isBreakingNews: true,
            }}
            overrideStyle={{
              dateStyle: "text-xs text-grey-400",
              contentWrapper: "flex flex-col-reverse mb-1 flex-grow basis-4/6",
              headerWrapper: "basis-2/6",
            }}
            {...article}
          />
        ))}
      </div>
    </div>
  ) : null;
}
